import React from "react";

const AnalyticsRoute = ({ children }) => {
    return children;
};

export default AnalyticsRoute;
